import { MatchLabel } from "../Match";
import NoData from "@/components/client/NoData";

const MatchInfo = ({ match }) => {

  if (!match) {
    return (<NoData/>);
  }

  const field = match?.location ? match?.location : 'Không có thông tin';
  const referee = match?.referees?.name ? match?.referees?.name : 'Không có thông tin';
  const temp = match?.temperature ? match?.temperature : 'Không có thông tin';
  const weather = match?.weather ? match?.weather : 'Không có thông tin';
  const wind = match?.wind ? match?.wind : 'Không có thông tin';
  const humidity = match?.humidity ? match?.humidity : 'Không có thông tin';
  const rain = match?.rain ? match?.rain : 'Không có thông tin';


  const info = [
    { 'Sân': field },
    { 'Trọng tài': referee },
    { 'Nhiệt độ': temp },
    { 'Thời tiết': weather },
    { 'Gió': wind },
    { 'Độ ẩm': humidity },
    { 'Xác xuất Mưa': rain }
  ] 

  return (
    <>  
    <div className="mt-8">
      <MatchLabel label={'Thông tin'}/>
      <div className="rounded overflow-hidden">
        <Info info={info}/>
      </div>
    </div>
    </>
  );
};

const Info = ({info}) => {
  return (
    <>
    <div className="@lg:grid @lg:grid-cols-7 gap-px">
      {
        info.map((item, index) => {
          return (
            <div key={index} className="flex @lg:flex-col justify-betwee border-b border-white dark:border-transparent @lg:border-l">
              <div className="shrink-0 grow-0 flex items-center @lg:justify-center @lg:h-10 text-gray-600 text-x1s w-1/2 @lg:w-full px-3 py-2 bg-light-gray dark:bg-league-dark dark:text-stroke-o3 font-semibold">{Object.keys(item)[0]}</div>
              <div className="shrink-0 grow-0 @lg:h-14 text-gray-800 text-x1s w-1/2 @lg:w-full px-3 py-2 bg-white dark:bg-dark-charcoal dark:text-stroke-o3 ">{Object.values(item)[0]}</div>
            </div>
          )
      })
    }
    </div>
    </>
  );
}; 
export default MatchInfo;